module.exports = __webpack_public_path__ + "img/product-4-mobile.d0073909.png";